{
  "id": "hel",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Hel",
    "en": "Hel"
  },
  "icon": "gods/hel",
  "portrait": "gods/hel-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "fire-giant": 1
  },
  "unlocks": ["fire-giant", "frost-giant", "mountain-giant", "rampage", "granite-blood"],
  "powers": ["nidhogg"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Loki. Focus: myth units. Enables Fire, Frost and Mountain Giants; only a Fire Giant is created on age up. Age tech MythicAgeHel."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "MythicAgeHel: CreateUnit fire-giant quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
